import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  assumptionNameSelect: {
    // reset '.section .field' marginTop: 16px
    marginTop: [0, '!important']
  }
})

export default useStyles
